import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=3450bf8c&scoped=true&"
import script from "./EmptyState.vue?vue&type=script&lang=js&"
export * from "./EmptyState.vue?vue&type=script&lang=js&"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=3450bf8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3450bf8c",
  null
  
)

export default component.exports